const zhTW = {
  // Navigation
  nav_plan: '計劃',
  nav_itinerary: '行程',
  nav_saved: '已儲存',

  // Header
  explore_photos: '探索照片',
  sign_in: '登入',

  // Plan screen
  new_trip: '+ 新行程',
  add_city_header: '新增城市',
  city_placeholder: '輸入城市名稱…',
  add_cities_empty: '新增城市以開始規劃行程',
  dest_bangkok: '曼谷', dest_paris: '巴黎', dest_london: '倫敦', dest_dubai: '杜拜',
  dest_singapore: '新加坡', dest_tokyo: '東京', dest_new_york: '紐約',
  dest_istanbul: '伊斯坦堡', dest_kuala_lumpur: '吉隆坡', dest_seoul: '首爾',
  hero_badge: 'AI 智慧行程規劃',
  hero_title_line1: '您的下次旅程，',
  hero_title_line2: '完美規劃。',
  hero_subtitle: '點選目的地，立即開始規劃',
  most_visited_label: '最受歡迎目的地',
  popular_destinations: '熱門目的地',
  or_type_your_own: '或自行輸入城市',
  where_going_label: '您要去哪裡？',
  expanding_region: (r) => `正在尋找 ${r} 的熱門城市…`,
  tap_to_explore: '— 點擊探索',
  attraction_count: (n) => `${n} 個景點`,
  show_less: '收起',
  read_more: '閱讀更多',
  more: '更多',
  less: '收起',
  no_attractions: '尚未新增景點',
  add_attraction_placeholder: (city) => `在 ${city} 新增景點…`,
  auto_add_title: '自動新增推薦景點',
  preferences_label: '興趣',
  all_types_label: '全部類型',
  edit_interests: '編輯興趣…',
  plan_framing_msg: '保留您喜歡的，移除其餘的，然後生成每日計劃。',
  add_back: '恢復',
  added_label: '已新增',
  refresh_attractions: '重新整理景點',
  plan_multi_summary: (n, m) => `${n} 個城市 · ${m} 個景點`,
  filter_onboarding_msg: '個性化您的景點',
  filter_onboarding_sub: '點選類型來聚焦 — 我們將重新產生符合的建議。',
  explore_nearby: '探索附近景點',
  explore_nearby_sub: '瀏覽行程中必看景點的照片',
  finding_attractions: '正在尋找景點…',
  finding_attractions_1: '正在詢問 AI 推薦…',
  finding_attractions_2: '尋找必訪景點…',
  finding_attractions_3: '快完成了…',
  generating_msg_1: '規劃您的行程天數…',
  generating_msg_2: '尋找最佳景點…',
  generating_msg_3: '製作您的旅遊行程…',
  view_itinerary: '查看行程',
  generate_itinerary: '生成行程',
  filterLabel: (label) => ({ 'All': '全部', 'Culture': '文化', 'Nature': '自然', 'Entertainment': '娛樂', 'Shopping': '購物', 'Food & Drink': '餐飲', 'Kids': '親子', 'Seniors': '樂齡' })[label] ?? label,

  // Itinerary screen
  rename: '重新命名',
  days: (n) => `${n} 天`,
  unsaved_dot: '未儲存的變更',
  share_itinerary: '分享行程',
  copy: '複製',
  copied: '已複製！',
  add_more_attractions: '新增更多景點',
  search_city_placeholder: '搜尋城市…',
  plus_city: '+ 城市',
  your_cities: '您的城市',
  unscheduled_count: (n) => `未排程景點（${n}）`,
  drag_to_schedule: '拖曳到天數以排程',
  loading_details: '載入詳細資訊中…',
  drag_here: '將景點拖曳至此',
  day_label: (n) => `第 ${n} 天`,
  activity_count: (n) => `${n} 個活動`,
  add_note: '+ 新增備註',
  note_placeholder: '這天的備註 — 飯店資訊、午餐地點、提醒事項…',
  save_note: '儲存備註',
  cancel: '取消',
  continue_in_city: '繼續在現有城市',
  change_back: '← 變更',
  save: '儲存',
  hotel_nights_label: '晚數',
  hotel_name_label: '飯店名稱',
  restaurant_label: '餐廳（選填）',
  search_hotel: '搜尋飯店…',
  search_restaurant: '搜尋餐廳…',
  searching: '搜尋中…',
  address_label: '地址',
  time_label: '時間',
  duration_label: '時長',
  notes_label: '備註',
  time_placeholder: '例如：上午 9:00',
  duration_placeholder: '例如：2 小時',
  notes_placeholder: '例如：下午 3 點辦理入住、泳池景觀房…',
  drag_to_reorder: '拖曳以重新排序',
  details: '詳細資訊',
  edit: '編輯',
  snip: 'Snip',
  remove: '移除',
  move_to_day_picker: '移至第…天',
  trip_start_date: '出發日期',
  itinerary_photo_sub: '根據您的城市，AI 智慧推薦',
  itinerary_photo_cta: '探索旅途中的隱藏寶藏',
  hotel: '飯店',
  meal_at: (restaurant) => `在 ${restaurant}`,
  add_day: '新增天數',
  save_changes: '儲存變更',
  saved_check: '已儲存 ✓',
  save_itinerary: '儲存行程',
  print_export: '🖨️ 列印 / 匯出 PDF',
  photos_details: '照片與詳細資訊',

  // Saved screen
  snip_requires_account: '建立免費帳號以儲存書籤',
  sign_in_to_save:'登入以儲存和查看您的行程',
  sign_in_or_create: '登入或建立帳戶',
  snips: 'Snips',
  place_count: (n) => `${n} 個地點`,
  trips: '行程',
  loading_trips: '載入行程中…',
  no_saved_trips: '尚無已儲存的行程',
  add_to_plan: '加入計劃',
  add_to_itinerary_btn: '加入行程',
  untitled_trip: '未命名行程',
  open: '開啟',

  // User menu
  signed_in_as: '已登入為',
  change_password: '變更密碼',
  delete_user_menu: '刪除使用者',
  sign_out: '登出',

  // Load saved trip confirmation
  load_trip_confirm_title: '開啟已儲存的行程？',
  load_trip_confirm_msg: '您目前的計劃將被捨棄。如需保留，請先儲存。',

  // New trip confirmation
  unsaved_changes_title: '未儲存的變更',
  unsaved_changes_msg: '您目前的行程有未儲存的變更。仍要開始新行程嗎？',
  discard_start_new: '捨棄並新建',
  new_trip_tab_title: '開始新行程？',
  new_trip_tab_msg: '您目前的行程將被清除。如需保留，請先儲存。',
  start_fresh: '重新開始',

  // Auth modal
  create_account: '建立帳戶',
  email_placeholder: '電子郵件',
  password_placeholder: '密碼',
  i_agree_to: '我同意',
  terms_of_service: '服務條款',
  privacy_policy: '隱私政策',
  and: '和',
  no_account: '還沒有帳戶？ ',
  have_account: '已有帳戶？ ',
  network_error: '網路錯誤，請再試一次',
  err_email_exists: '此電子郵件已有帳戶',
  err_invalid_credentials: '電子郵件或密碼無效',
  err_email_password_required: '電子郵件和密碼為必填',
  err_password_too_short: '密碼至少需要 6 個字元',

  // Change password modal
  select_user: '選擇使用者…',
  new_password_placeholder: '新密碼（至少 6 個字元）',
  update_password: '更新密碼',
  password_updated: '密碼已更新',
  select_a_user: '請選擇使用者',
  network_error_short: '網路錯誤',

  // Delete user modal
  delete_user_trips: '刪除使用者和行程',
  deleted_user: (email) => `已刪除 ${email}`,

  // Photo mode
  photo_loading_msg_1: '正在為您尋找精彩景點…',
  photo_loading_msg_2: '正在確認照片與詳情…',
  photo_loading_msg_3: '即將完成…',
  finding_places: '正在為您尋找地點…',
  could_not_load_places: '無法載入地點',
  no_places: '沒有可顯示的地點',
  ai_error: '連接 AI 時發生問題，請稍後再試。',
  add_cities_suggestions: '新增城市或儲存地點以獲取個人化建議。',
  retry: '重試',
  close: '關閉',
  finding_more_places: '正在尋找更多地點…',
  seen_it_all: '您已看完所有地點！',
  photo_limit_msg: '您已達到本次工作階段 50 個地點的上限。',
  check_snips: '查看您的 Snips 以複習已儲存的地點',
  photo_unavailable: '照片無法顯示',
  loading: '載入中…',
  skip: '略過',
  plus_itinerary: '+ 行程',
  plus_plan: '+ 計劃',
  photo_explore_title: '照片探索',
  photo_explore_sub: '以視覺方式發現地點',
  swipe_lr: '左右滑動略過',
  swipe_up: '向上滑動略過',
  lets_go: '出發！',
  tutorial_skip_desc: '略過此地點',
  tutorial_snip_desc: '儲存至 Snips 收藏，稍後再看',
  tutorial_add_plan_desc: '加入計劃分頁',
  tutorial_add_itinerary_desc: '直接加入目前行程',
  tutorial_swipe_hint: '也可以左右或向上滑動略過',

  // Footer
  copyright: '© 2026 Pazzie Inc.',
  terms: '條款',
  privacy: '隱私',
  sample_itineraries: '範例行程',
  browse_all_itineraries: '瀏覽全部 →',

  // Legal overlay
  back_to_app: '← 返回 SnipTrip',

  // Error boundary
  something_wrong: '發生錯誤',
  reload: '重新載入',

  // Print view
  copy_text: '複製文字',
  copied_check: '✓ 已複製',

  // Logic / computed strings
  copy_of: (name) => `${name} 的副本`,
  transportation: '交通',
  meal: '餐點',

  // Chat mode
  chat_mode_link: '或使用 AI 對話規劃',
  chat_back: '← 返回建立模式',
  chat_input_placeholder: '傳送訊息…',
  chat_error: '發生錯誤，請再試一次。',
  chat_cities_count: (n) => `${n} 個城市`,
  chat_places_count: (n) => `${n} 個景點`,
  chat_no_cities: '尚未新增城市',

  // Discovery panels
  thinking_where: '正在思考帶您去哪裡…',
  couldnt_load_suggestions: '無法載入建議。再試一次？',
  back: '← 返回',
  no_new_suggestions: '沒有新建議 — 請嘗試其他問題。',
  back_to_questions: '← 返回問題',
  dismiss: '關閉',
  where_to_next_header: '接下來去哪？',
  describe_place: '描述地點類型…',
  go: '前往',
  finding_ideas: '尋找靈感中…',
  more_attractions: '更多景點…',
  different_angle: '或從不同角度探索：',
  mood_for: '您現在想做什麼？',
  back_questions_short: '← 問題',
  describe_looking_for: '描述您在尋找什麼…',
  where_to_next_trigger: (city) => city ? `+ 接下來去${city}之後哪裡？` : '+ 接下來去哪？',
  what_else_trigger: (city) => `+ 在${city}附近還應該加什麼？`,
  day_chip_add_attraction: '新增景點',
  day_chip_add_city: '新增附近城市',
  auto_populate_prompt: (city) => `自動推薦${city}的熱門景點？`,
  auto_populate_yes: '是，推薦一些',
  auto_populate_no: '不，我自己新增',
  or_discover_new: '+ 或探索新地方',
  select: '選擇',
  add: '新增',
  freeform_cta: '其他 — 我來描述',
};

export default zhTW;
